import React from "react";
import { Redirect } from "react-router-dom";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import { canAccessModule, pickDefaultRoute, parseTillAccess } from "../../constants/accessControl";

// Wraps a POS-family screen and redirects to the user's actual reachable screen
// (TSK-2997) instead of rendering a dead "Access Denied" page.
const ModuleGate = ({ module, children }) => {
  const tillData = useAuthStore((s) => s.tillData);
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const tillaccess = parseTillAccess(tillData);

  if (!canAccessModule(module, { posConfig, tillaccess })) {
    return <Redirect to={pickDefaultRoute({ posConfig, tillaccess })} />;
  }

  return children;
};

export default ModuleGate;
